export const API_URL = "https://api.juniortoes.com";